/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Cadence_One_LinerInputs */

const en_exp_cadence_one_liner = /** @type {(inputs: Exp_Cadence_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your average steps or revolutions per minute during the session.`)
};

const de_exp_cadence_one_liner = /** @type {(inputs: Exp_Cadence_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Ø Schritte oder Umdrehungen pro Minute.`)
};

/**
* | output |
* | --- |
* | "Your average steps or revolutions per minute during the session." |
*
* @param {Exp_Cadence_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_cadence_one_liner = /** @type {((inputs?: Exp_Cadence_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Cadence_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_cadence_one_liner(inputs)
	return de_exp_cadence_one_liner(inputs)
});